// extracted by mini-css-extract-plugin
export default {"cardContainer":"styles_cardContainer__-gIeL","dark":"styles_dark__rOhE1"};